:host {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  font-size: calc(var(--default-font-size) * (14 / 12));
  gap: var(--spacer-8);
  overflow: hidden;
}
#months {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--spacer-8);
}
abbr {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: normal;
  color: var(--theme-secondary-text);
  display: inline-block;
  aspect-ratio: 1 / 1;
}
table {
  table-layout: fixed;
  min-width: 17em;
}
caption {
  padding-bottom: var(--spacer-4);
}
thead {
  font-size: var(--default-font-size);
  vertical-align: top;
}
#caption-inner {
  display: flex;
  margin-left: var(--spacer-2);
  margin-right: var(--spacer-2);
  white-space: nowrap;
  justify-content: space-between;
}
#month-year {
  text-align: left;
  display: inline-flex;
  gap: 0.8ch;
}
.input-container {
  position: relative;
}
.input-container :is(input, select) {
  all: inherit;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  border: none;
  padding: 0;
  opacity: 0;
}
.input-container :is(input, select):focus + * {
  visibility: hidden;
}
.input-container input {
  padding-left: 0.2em;
  left: -0.2em;
  background: white;
}
/* Fix Firefox specific rendering issue */
@supports (-moz-appearance: none) {
  .input-container select {
    text-indent: -2px;
  }
}

:is(input, select):focus-visible {
  opacity: 1;
  box-shadow: var(--box-shadow-focus-ring);
  z-index: 1;
  border-radius: var(--Common--border-radius);
}
:is(input):focus-visible {
  width: auto;
}
#inputs {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: var(--spacer-1);
  margin-bottom: var(--spacer-2);
  order: 1;
}
#inputs :is(input, select) {
  padding: 0 var(--spacer-05);
  border: none;
  background: var(--theme-secondary-background);
  border-radius: var(--Common--border-radius);
}
#inputs input {
  text-align: right;
}
.controls {
  display: inline-flex;
  gap: var(--spacer-2);
  align-items: center;
  padding-left: var(--spacer-2);
}
.controls aha-button {
  border: none;
  min-width: unset;
}
.controls aha-button:hover,
.controls aha-button:focus-visible {
  position: relative;
  z-index: 1;
}
#calendar-controls aha-icon {
  font-size: calc(var(--default-font-size) * (14 / 12));
}
#month-controls {
  margin-left: auto;
}

.tooltip-body {
  white-space: nowrap;
}
:is(thead, tbody) tr > * {
  position: relative;
  padding: 0;
  width: 2em;
}
:is([data-type='previous'], [data-type='next']) {
  color: lightgray;
}
:host([view]) :is([data-type='previous'], [data-type='next']) {
  visibility: hidden;
}
td {
  text-align: center;
  transition: transform 0.1s linear;
  transform: scale(1);
}
td .date-number {
  position: relative;
  width: 100%;
  z-index: 5;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}

tbody td:not(:empty)::after {
  cursor: pointer;
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: var(--Common--border-radius);
  transform: translate(-50%, -50%);
  z-index: 2;
  background: none;
  box-shadow: none;
  transition: background 0.1s linear, box-shadow 0.1s linear;
}

tbody td:focus-visible {
  outline: none;
}
tbody td:focus-visible::after {
  border: 1px solid var(--aha-gray-500);
}
tbody td:hover {
  color: var(--theme-primary-text);
  transform: scale(1.2);
  position: relative;
  z-index: 1;
}
tbody td:focus {
  z-index: 2;
}
tbody td:hover::after {
  background: var(--theme-button-border);
}
tbody td[data-today] {
  color: var(--theme-blue-text);
}
tbody td[data-today]::after {
  background: var(--theme-blue-background);
}

tbody td[data-selected] {
  color: white;
  position: relative;
  font-weight: 700;
}
tbody td[data-selected]::after {
  background: var(--aha-blue-500);
}
#day {
  width: 4ch;
}
#year {
  width: 6ch;
}
aha-tooltip {
  width: 100%;
  aspect-ratio: 1;
  position: absolute;
  cursor: pointer !important;
}
.calendar-events {
  position: absolute;
  left: 0;
  top: 60%;
  bottom: 0;
  right: 0;
  background: lime;
  z-index: 4;
}
.event-contents {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);
  padding-bottom: var(--spacer-2);
}
.event-dots {
  height: 2ex;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.5ex;
  overflow: hidden;
  font-size: 0.8ex;
  width: 8ex;
  position: absolute;
  bottom: 8%;
}
.event-dot {
  aspect-ratio: 1;
  background: var(--aha-calendar--color-dot);
  border-radius: 50%;
}
